/* eslint-disable */ 

export const storeModuleNames = {
    MAP_FOR_ROUTES: 'mapForRoutes'
}

export const operators = {
    MY_AGENT: [226, 299],
};

export const POST_MESSAGE_DOMAINS = new Set(['tinkoff.mobapp', 't-bank.mobapp']);
